import AgencyInfoCard from './AgencyInfoCard';
import AgencyStatCards from './AgencyStatCards';
import AgencyWeatherSection from './AgencyWeatherSection';
import AgencyFarmMap from './AgencyFarmMap';
import PageHeader from '@components/common/PageHeader';

/**
 * AgencyDashboard
 * 대행사 메인 대시보드 페이지
 *
 * Layout:
 *  1. AgencyInfoCard          col-12  대행사 기본정보
 *  2. AgencyStatCards         col-12 col-md-3  작기수/농지수/면적/작물수
 *  3. AgencyWeatherSection    col-12  오늘날씨 + 시간대별 날씨
 *  4. AgencyFarmMap           col-12  농지 지도 (네이버 + 마커)
 *  5. AgencyFarmList          col-12 col-md-6  농지 목록
 *  6. AgencyRecommendedTasks  col-12 col-md-6  추천 농작업
 */
const AgencyDashboard = () => {
    return (
        <div className="container-fluid p-3">
            <PageHeader
                title="대시보드"
                breadcrumbs={[
                    { label: '홈', href: '/' },
                    { label: '대시보드', active: true },
                ]}
            />

            {/* ① 대행사 기본정보 */}
            <div className="row mt-3">
                <div className="col-12">
                    <AgencyInfoCard />
                </div>
            </div>

            {/* ② 주요 통계 4종 */}
            <AgencyStatCards />

            {/* ④ 농지 지도 */}
            <div className="row mb-3">
                <div className="col-12">
                    <AgencyFarmMap />
                </div>
            </div>

            {/* ③ 날씨 정보 */}
            <AgencyWeatherSection />

            {/* ⑤ 농지목록 + ⑥ 추천농작업 */}
            {/*            <div className="row g-3">
                <div className="col-12 col-md-6">
                    <AgencyFarmList />
                </div>
                <div className="col-12 col-md-6">
                    <AgencyRecommendedTasks />
                </div>
            </div>*/}
        </div>
    );
};

export default AgencyDashboard;
